import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const imageUrl = (path) => `${API}/api/public/files/${path}`;

export function PublicFooter({ compact }) {
  const [legal, setLegal] = useState(null);

  useEffect(() => {
    axios.get(`${API}/api/public/site-content`).then(({ data }) => setLegal(data.legal_info)).catch(() => {});
  }, []);

  if (!legal) return null;

  const infoLine = [
    legal.professional_name,
    legal.cedula_profissional ? `Cédula ${legal.cedula_profissional}` : '',
    legal.ers_clinic ? `ERS n.º ${legal.ers_clinic}` : '',
    legal.ers_telemedicine ? `Registo ERS (telemedicina): ${legal.ers_telemedicine}` : '',
  ].filter(Boolean).join(' · ');
  const addressLine = [legal.nif ? `NIF ${legal.nif}` : '', legal.morada || '', legal.telefone ? `Tel. ${legal.telefone}` : ''].filter(Boolean).join(' · ');

  return (
    <footer className={`text-center ${compact ? 'mt-8 pt-4' : 'mt-10 pt-6 px-4'} border-t border-brand-border/60`} data-testid="public-footer">
      <a href={legal.livro_reclamacoes_url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-xs font-medium text-brand-green hover:underline" data-testid="livro-reclamacoes-link">
        {legal.livro_reclamacoes_logo_path ? (
          <img src={imageUrl(legal.livro_reclamacoes_logo_path)} alt="Livro de Reclamações Eletrónico" className="h-8" data-testid="livro-reclamacoes-logo" />
        ) : (
          'Livro de Reclamações Eletrónico'
        )}
      </a>
      <p className="text-[11px] text-[#5F665B] mt-2 px-2" data-testid="public-footer-info-line">{infoLine}</p>
      {addressLine && <p className="text-[11px] text-[#5F665B] mt-0.5 px-2" data-testid="public-footer-address-line">{addressLine}</p>}
    </footer>
  );
}

export default PublicFooter;
